<template>
  <div>
    <div v-if="isLoading" class="text-center pt-3">
      <b-spinner label="Loading..." />
    </div>
    <template v-else>
      <div class="custom-search d-flex justify-content-end">
        <b-form-group>
          <b-button variant="primary" class="float-right" v-b-modal.add-modal @click="openAddModal">
            <span> Add Company </span>
          </b-button>
        </b-form-group>
      </div>
      <b-card-group deck class="justify-content-left">
        <b-card
            v-for="company in companies"
            :key="company.id"
            no-body
            :class="'unit-block mb-2 p-1'"
            :img-src="company.picture"
            img-alt="Image"
            img-top
        >
          <b-card-body>
            <b-card-title class="text-primary">{{ company.name }}</b-card-title>
            <b-card-text>{{ company.description }}</b-card-text>
          </b-card-body>

          <b-list-group flush>
            <b-list-group-item>
              <strong>Email:</strong> {{ company.email }}
            </b-list-group-item>
            <b-list-group-item>
              <strong>Phone:</strong> {{ company.phone }}
            </b-list-group-item>
          </b-list-group>

          <b-card-body class="d-flex flex-column-reverse">
            <b-button
                v-b-modal.edit-modal
                block
                variant="success"
                @click="openEditModal(company)"
            >
              <span class="text-light">Edit details</span>
            </b-button>
          </b-card-body>
        </b-card>

        <b-modal
            id="edit-modal"
            title="Edit company details"
            ok-title="Save"
            cancel-variant="outline-secondary"
            @ok="editSubmit"
        >
          <b-form>
<!--            <validation-observer ref="editValidation">-->
              <b-form-group label="Name" label-for="name">
<!--                <validation-provider #default="{ errors }" name="name" rules="required">-->
                  <b-form-input v-model="edited.name" placeholder="Enter company name"/>
                  <small class="text-danger">{{ /*errors[0]*/ '' }}</small>
                <!-- </validation-provider>-->
              </b-form-group>
              <b-form-group label="Description" label-for="description">
<!--                <validation-provider #default="{ errors }" name="description" rules="max:250">-->
                  <b-form-textarea v-model="edited.description" placeholder="Enter company description" rows="3" max-rows="6"/>
                  <small class="text-danger">{{ /*errors[0]*/ '' }}</small>
                <!-- </validation-provider>-->
              </b-form-group>
              <b-form-group label="Picture" label-for="picture">
                <b-form-file v-model="edited.picture" placeholder="Choose a file or drop it here..." drop-placeholder="Drop file here..."/>
              </b-form-group>
              <b-form-group label="Email" label-for="email">
                <b-form-input v-model="edited.email" placeholder="Enter company email address" type="email"/>
              </b-form-group>
              <b-form-group label="Phone" label-for="phone">
                <b-form-input v-model="edited.phone" placeholder="Enter company phone number" required type="number"/>
              </b-form-group>
            <!-- </validation-observer>-->
          </b-form>

          <template #modal-footer>
            <b-button
                variant="outline-secondary"
                class="float-right"
                @click="$bvModal.hide('edit-modal')"
            >
              Close
            </b-button>
            <b-button
                variant="primary"
                class="float-right"
                @click="editSubmit"
                :disabled="isEditLoading"
            >
              <b-spinner
                  v-if="isEditLoading"
                  label="Spinning"
                  small
              />
              <span v-else>
              Save
            </span>
            </b-button>
          </template>
        </b-modal>

        <b-modal id="add-modal" title="Add new company" ok-title="Save" cancel-variant="outline-secondary" @ok="addSubmit">
          <b-form>
<!--            <validation-observer ref="addValidation"> -->
              <b-form-group label="Name" label-for="name">
<!--                <validation-provider #default="{ errors }" name="name" rules="required">-->
                  <b-form-input v-model="edited.name" placeholder="Enter company name"/>
                  <small class="text-danger">{{ /*errors[0]*/ '' }}</small>
                <!-- </validation-provider>-->
              </b-form-group>
              <b-form-group label="Description" label-for="description">
<!--                <validation-provider #default="{ errors }" name="description" rules="max:250">-->
                  <b-form-textarea v-model="edited.description" placeholder="Enter company description" rows="3" max-rows="6"/>
                  <small class="text-danger">{{ /*errors[0]*/ '' }}</small>
                <!-- </validation-provider>-->
              </b-form-group>
              <b-form-group label="Picture" label-for="picture">
                <b-form-file v-model="edited.picture" placeholder="Choose a file or drop it here..." drop-placeholder="Drop file here..."/>
              </b-form-group>
              <b-form-group label="Phone number" label-for="phone">
                <b-form-input v-model="edited.phone" placeholder="Enter company phone number" required type="number"/>
              </b-form-group>
              <b-form-group label="Email address" label-for="email">
                <b-form-input v-model="edited.email" placeholder="Enter company email" type="email"/>
              </b-form-group>
            <!-- </validation-observer>-->
          </b-form>
          <template #modal-footer>
            <b-button variant="outline-secondary" class="float-right" @click="$bvModal.hide('add-modal')">Close</b-button>
            <b-button variant="primary" class="float-right" @click="addSubmit" :disabled="isEditLoading">
              <b-spinner v-if="isEditLoading" label="Spinning" small/>
              <span v-else>Save</span>
            </b-button>
          </template>
        </b-modal>
      </b-card-group>
    </template>
  </div>
</template>

<script>
import {
  BCard,
  BCardBody,
  BCardTitle,
  BCardText,
  BListGroup,
  BListGroupItem,
  BFormDatepicker,
  BButton,
  BModal,
  BFormGroup,
  BFormInput,
  BFormFile,
  BForm,
  BCardGroup,
  BSpinner,
  BFormTextarea,
} from 'bootstrap-vue'
import { mapActions, mapGetters } from 'vuex'
import { toastSuccess, toastFailure } from '@/libs/toastification'

export default {
  components: {
    BCard,
    BCardBody,
    BCardTitle,
    BCardText,
    BListGroup,
    BListGroupItem,
    BFormDatepicker,
    BButton,
    BModal,
    BFormGroup,
    BFormInput,
    BFormFile,
    BForm,
    BCardGroup,
    BSpinner,
    //ValidationProvider,
    //ValidationObserver,
    BFormTextarea,
  },
  data() {
    return {
      minDate: new Date(),
      isLoading: true,
      edited: {
        name: null,
        description: null,
        picture: null,
        phone: null,
        email: null
      },
      temporaryPicture: null,
      isEditLoading: false,
      //required,
      //max,
    }
  },
  computed: {
    ...mapGetters({
      companies: 'companies/companies',
    }),
  },
  async mounted() {
    await this.loadCompanies().catch(() => {
        toastFailure('Something went wrong.')
      }
    )

    this.isLoading = false
  },
  methods: {
    ...mapActions({
      loadCompanies: 'companies/loadCompanies',
      updateCompany: 'companies/updateCompany',
      addCompany: 'companies/addCompany',
    }),
    onContext(ctx) {
      this.formatted = ctx.selectedFormatted;
      this.selected = ctx.selectedYMD;
    },
    openEditModal(company) {

      this.edited.id = company.id
      this.edited.name = company.name
      this.edited.description = company.description
      this.edited.phone = company.phone
      this.edited.email = company.email
    },
    openAddModal() {

      this.edited.id = 0;
      this.edited.name = '';
      this.edited.description = '';
      this.edited.phone = null;
      this.edited.email = null;
    },
    editSubmit() {
      this.submitForm('edit')
      /*this.$refs.editValidation.validate().then(success => {
        if (success) {
          this.submitForm('edit')
        }
      })*/
    },
    addSubmit() {
      this.submitForm('add')
      /*this.$refs.addValidation.validate().then(success => {
        if (success) {
          this.submitForm('add')
        }
      })*/
    },
    async submitForm(action) {
      this.isEditLoading = true

      const formData = new FormData()

      /* eslint-disable-next-line */
      for (const [key, value] of Object.entries(this.edited)) {
        if (value) formData.append(key, value)
      }

      if (this.edited.picture) {
        await this.getTemporaryPicture()
      }

      if (action == 'edit') {

        formData.append('_method', 'PUT');
        this.updateCompany({ formData })
            .then(() => {
              toastSuccess('Your changes have been updated.')
              this.isEditLoading = false
              this.$root.$emit('bv::hide::modal', 'edit-modal')
            })
            .catch(() => { toastFailure('Something went wrong.') })
      } else {

        formData.append('_method', 'POST');
        this.addCompany({ formData })
            .then(() => {
              toastSuccess('The company successfully added.')
              this.isEditLoading = false
              this.$root.$emit('bv::hide::modal', 'add-modal')
            })
            .catch(() => { toastFailure('Something went wrong.') })
      }

      this.edited.picture = null
      this.temporaryPicture = null
    },
    getTemporaryPicture() {
      return new Promise(resolve => {
        const reader = new FileReader()

        reader.addEventListener('load', () => {
          this.temporaryPicture = reader.result
          resolve()
        }, false)

        if (/\.(jpe?g|png|gif)$/i.test(this.edited.picture.name)) {
          reader.readAsDataURL(this.edited.picture)
        }
      })
    },
  },
}
</script>
